import React, { useState, useMemo } from "react";
import clsx from "clsx";
import { OrgsModal } from "@src/components/modals/orgs/orgs.modal";
import {
  OrganizationBox,
  ORGS_DISPLAY_LIMIT,
  RemainderBox,
} from "./organization.box";

import "./organizations.section.scss";
import { ZeroStateMessage } from "@src/components/zero-state-message/zero-state-message";

export const OrganizationsSection = ({ menu, className }) => {
  const { organizations, name } = menu;
  const [menuOrgsModalOpen, setMenuOrgsModalOpen] = useState();

  const firstThreeOrganizations = useMemo(() => {
    if (!organizations || organizations.length <= ORGS_DISPLAY_LIMIT) {
      return organizations;
    }
    return organizations.slice(0, ORGS_DISPLAY_LIMIT);
  }, [organizations]);

  return (
    <div className={clsx("organizations-section", className)}>
      <h2>Organizations</h2>
      <div className="box-section">
        {organizations && organizations.length > 0 ? (
          <>
            {firstThreeOrganizations.map((org) => (
              <OrganizationBox
                key={org.id}
                organization={org}
                breadcrumbLabel={org.name}
              />
            ))}
            <RemainderBox
              organizations={organizations}
              onClick={() => setMenuOrgsModalOpen(true)}
            />
          </>
        ) : (
          <ZeroStateMessage text="There are no organizations configured with this menu." />
        )}
      </div>
      {organizations && organizations.length > ORGS_DISPLAY_LIMIT && (
        <OrgsModal
          open={menuOrgsModalOpen}
          entity={menu}
          onClose={() => setMenuOrgsModalOpen()}
          breadcrumbLabel={name}
        />
      )}
    </div>
  );
};
